import { render, staticRenderFns } from "./FooterServices.vue?vue&type=template&id=dac907be&scoped=true"
import script from "./FooterServices.vue?vue&type=script&lang=js"
export * from "./FooterServices.vue?vue&type=script&lang=js"
import style0 from "./FooterServices.vue?vue&type=style&index=0&id=dac907be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac907be",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Ffooter-services%2FFooterServices.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports